module.exports = __webpack_public_path__ + "img/wait.f8d51a24.gif";